/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BonusGrantPlanListVo } from './BonusGrantPlanListVo';
import {
    BonusGrantPlanListVoFromJSON,
    BonusGrantPlanListVoFromJSONTyped,
    BonusGrantPlanListVoToJSON,
    BonusGrantPlanListVoToJSONTyped,
} from './BonusGrantPlanListVo';

/**
 * 
 * @export
 * @interface ResponseBonusGrantPlanListVo
 */
export interface ResponseBonusGrantPlanListVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseBonusGrantPlanListVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseBonusGrantPlanListVo
     */
    message?: string;
    /**
     * 
     * @type {BonusGrantPlanListVo}
     * @memberof ResponseBonusGrantPlanListVo
     */
    data?: BonusGrantPlanListVo;
}

/**
 * Check if a given object implements the ResponseBonusGrantPlanListVo interface.
 */
export function instanceOfResponseBonusGrantPlanListVo(value: object): value is ResponseBonusGrantPlanListVo {
    return true;
}

export function ResponseBonusGrantPlanListVoFromJSON(json: any): ResponseBonusGrantPlanListVo {
    return ResponseBonusGrantPlanListVoFromJSONTyped(json, false);
}

export function ResponseBonusGrantPlanListVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseBonusGrantPlanListVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : BonusGrantPlanListVoFromJSON(json['data']),
    };
}

export function ResponseBonusGrantPlanListVoToJSON(json: any): ResponseBonusGrantPlanListVo {
    return ResponseBonusGrantPlanListVoToJSONTyped(json, false);
}

export function ResponseBonusGrantPlanListVoToJSONTyped(value?: ResponseBonusGrantPlanListVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': BonusGrantPlanListVoToJSON(value['data']),
    };
}

